import React, { ChangeEvent, memo, useCallback } from 'react'
import { MenuOption } from '@maas-components/core'
import { FormikProps } from 'formik'
import TextField from 'core/components/TextField'
import { ProductFreightV2Values } from '../constants'

export type TOptions = {
  value: string
  label: string
}

interface CustomSelectProps {
  options: TOptions[]
  disabled?: boolean
  label: string
  name: string
  value: string
  onSelect: (selectedOption: string) => void
  handleChange: FormikProps<ProductFreightV2Values>['handleChange']
  id?: string
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  disabled,
  name,
  label,
  value,
  onSelect,
  handleChange,
  id,
}) => {
  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target
      onSelect(value)
      handleChange(e)
    },
    [onSelect, handleChange]
  )

  return (
    <TextField
      variant="outlined"
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      hiddenLabel
      fullWidth
      select
      id={id}
    >
      {options?.map(({ value, label }) => (
        <MenuOption key={value} value={value} selected={value === 'standard'}>
          {label}
        </MenuOption>
      ))}
    </TextField>
  )
}

export default memo(CustomSelect)
